(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.breakpoints = {
        desktop: 750,
      };
    }

    connectedCallback() {
      this.initSlider();
      this.setProductMediaWidth();
      window.addEventListener("resize", this.setProductMediaWidth.bind(this));
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        slidesPerView: parseInt(this.dataset.productsPerViewMobile),
        spaceBetween: 6,
        breakpoints: {
          750: {
            slidesPerView: parseInt(this.dataset.productsPerView),
            spaceBetween: 10,
          },
        },
      };
      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }
      if (this.hasAttribute('data-mobile-slider-destroy')) {
        this.options.slidesPerView = 1;
        this.options.allowTouchMove = false;
        this.options.autoHeight = true;

        this.options.breakpoints = {
          [this.breakpoints.desktop]: {
            slidesPerView: 4,
            spaceBetween: 10,
            allowTouchMove: true,
          },
          1023: {
            slidesPerView: 5,
          },
        };
      }
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }

    setProductMediaWidth() {
      if(document.querySelector('[data-product-media-slider]') && document.querySelector('[data-feed-container]')) {
        const mediaWidth = document.querySelector('[data-product-media-slider]').clientWidth;
        document.querySelector('[data-feed-container]').style.width = `${mediaWidth}px`
      }
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
